import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postUpdateUsageURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
  } from "@chakra-ui/react";

function EditUsage({
    isOpen,
    onClose,
    successCallback,
    userData
}) {

    const [ purpose, setPurpose ] = useState('');
    const [ amount, setAmount ] = useState('0.0');

    const [ invPurpose, setInvPurpose ] = useState(null);
    const [ invAmount, setInvAmount ] = useState(null);

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    const postUsagees = (e) => {
        e.preventDefault();

        let id;
        if (userData) {
            id = userData.id;
        } 

        const floatAmount = parseFloat(amount);
        if (floatAmount <= 0) {
            setErrors(['Amount must be greater than zero']);
            return;
        }

        setErrors([]);
        setSubmitting(true);
        // console.log(email, password);
        axios.post(postUpdateUsageURL(id), 
        {
            purpose,
            amount,
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {

        if (!validator.isEmpty(purpose)) {
            setInvPurpose(purpose.length < 1);
        }

        if (!validator.isEmpty(amount)) {
            setInvAmount(!validator.isNumeric(amount));
        }

    }, [amount, purpose]);

    useEffect(() => {
        // console.log(userData);

        if (userData) {
            setAmount(userData.amount);
            setPurpose(userData.purpose);
        }

    }, [userData]);

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Edit Usage</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <form onSubmit={postUsagees}>
                    <FormControl >

                    {/* On backend its originally 'purpose' just relaballed it to description */}
                    <Box pr="12px">
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Description
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="text"
                            placeholder="Description"
                            size="md" 
                            isInvalid={invPurpose === true}
                            isRequired={true}
                            value={purpose} 
                            onChange={e => setPurpose(e.target.value)}
                        />
                    </Box>
                  
                    <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                        Amount
                    </FormLabel>
                    <Input
                        borderRadius="15px"
                        mb="12px"
                        fontSize="sm"
                        type="text"
                        placeholder="1000.5"
                        size="md" 
                        isInvalid={invAmount === true}
                        isRequired={true}
                        value={amount} 
                        onChange={e => setAmount(e.target.value)}
                    />


                    <Flex w="100%" flexDir="column">
                        { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                    </Flex>
                    <Button
                        fontSize="10px"
                        type="submit"
                        bg="teal.300"
                        w="100%"
                        h="45"
                        mb="20px"
                        color="white"
                        mt="0px"
                        _hover={{
                        bg: "teal.200",
                        }}
                        _active={{
                        bg: "teal.400",
                        }}
                        isDisabled={submitting}
                    >
                        SAVE
                    </Button>
                </FormControl>
            </form>
            </ModalBody>
            {/* <ModalFooter>
                <Flex w="100%"
                flexDirection={{
                sm: "row",
                md: "row",
                }} 
                alignItems={{ xl: "center" }}>
                <Button variant="ghost" onClick={onClose}>Cancel</Button>
                <Spacer />
                <Button colorScheme="teal" mr={3} >
                    Submit
                </Button>
                </Flex>
            </ModalFooter> */}
            </ModalContent>
        </Modal>
    );

}



export default EditUsage;
